import {CODE_RESEND_DELAY_IN_SECONDS} from "@pg-mono/user";

import {IReservationAuthState} from "../types/IReservationAuthState";

// Official requirement of the Vox booking API: the verification code e-mailed to the user is always exactly 6 digits.
// It is not a design choice - do not change it to match a mockup; the input count and the copy are derived from it.
export const RESERVATION_CODE_LENGTH = 6;
// used when the initiate response comes without `expires_in`
export const HANDLE_TTL_FALLBACK_S = 600;
export const RESEND_COOLDOWN_S = CODE_RESEND_DELAY_IN_SECONDS;
// lock applied when a 429 comes without Retry-After
export const RATE_LIMIT_FALLBACK_S = 60;
// a confirm waits for the CRM, so it gets longer than the generic API timeout - a confirm cut off by the client may still have reserved the property
export const CONFIRM_TIMEOUT_MS = 60_000;
// the CRM limit of the first name and of the last name, each on its own
export const FULL_NAME_PART_MAX_LENGTH = 100;
// the CRM sends at most 3 codes per e-mail within 10 minutes - another one would only get a 429
export const MAX_CODES_PER_WINDOW = 3;
export const CODE_SEND_WINDOW_MIN = 10;
// how long the local "reserved by me" marker overrides availability data, which can be stale right after a confirm
export const RESERVED_MARKER_TTL_MIN = 24 * 60;
// an expired session restarts the registration from its beginning - the cached profile can outlive the session
export const SIGNED_OUT_RESERVATION_AUTH_STATE: IReservationAuthState = {isUserLoggedIn: false, hasCompleteProfile: false, hasPhoneVerified: false};
import {CODE_RESEND_DELAY_IN_SECONDS} from "@pg-mono/user";

import {IReservationAuthState} from "../types/IReservationAuthState";

// Official requirement of the Vox booking API: the verification code e-mailed to the user is always exactly 6 digits.
// It is not a design choice - do not change it to match a mockup; the input count and the copy are derived from it.
export const RESERVATION_CODE_LENGTH = 6;
// used when the initiate response comes without `expires_in`
export const HANDLE_TTL_FALLBACK_S = 600;
export const RESEND_COOLDOWN_S = CODE_RESEND_DELAY_IN_SECONDS;
// lock applied when a 429 comes without Retry-After
export const RATE_LIMIT_FALLBACK_S = 60;
// a confirm waits for the CRM, so it gets longer than the generic API timeout - a confirm cut off by the client may still have reserved the property
export const CONFIRM_TIMEOUT_MS = 60_000;
// the CRM limit of the first name and of the last name, each on its own
export const FULL_NAME_PART_MAX_LENGTH = 100;
// the CRM sends at most 3 codes per e-mail within 10 minutes - another one would only get a 429
export const MAX_CODES_PER_WINDOW = 3;
export const CODE_SEND_WINDOW_MIN = 10;
// how long the local "reserved by me" marker overrides availability data, which can be stale right after a confirm
export const RESERVED_MARKER_TTL_MIN = 24 * 60;
// an expired session restarts the registration from its beginning - the cached profile can outlive the session
export const SIGNED_OUT_RESERVATION_AUTH_STATE: IReservationAuthState = {isUserLoggedIn: false, hasCompleteProfile: false, hasPhoneVerified: false};
